import { format, parse } from 'date-fns';
import { getLocationAddress } from '@/utils/helpers';
import { Location } from '@/api/types';
import { emptyLocation } from './config';

export const formatForDatePicker = (dateString?: string | null) => {
  if (!dateString) return null;
  return format(dateString || '', 'yyyy-MM-dd');
};

export const formatForTimePicker = (timeString?: string | null) => {
  if (!timeString) return null;
  const toFormatTime = parse(timeString, 'HH:mm', new Date());
  return format(toFormatTime, 'HH:mm:ss');
};

export const formatCaseFacilityLocation = (location?: Location) =>
  location
    ? {
        ...location,
        addressId: location.id,
        title: getLocationAddress(location),
      }
    : emptyLocation;
